import React from "react";
import SkeletonElement from "Components/GMS/Category/Shimmer/SkeletonElement";

type MyProps = {
    loading: {status?: string, message?: string}
}

const LoadingSuccessErrorAlert = ({ loading }: MyProps) => {
    return (
      <>
        {loading.status === "Saving" && (
          <div className="alert alert-primary bg-white small p-2" role="alert">
            <span className="fas fa-circle-notch fa-spin" />
            &nbsp;
            <strong>{loading.message}</strong>
          </div>
        )}
        {loading.status === "Loading" && (
          <div className="d-flex w-100 h-100 ms-4 ">
            {/* <Loader width="120px" height="120px" /> */}
            <div className="row w-100 mt-0 mb-3">
              <div className="col col-md-12 cat">
                <div className="card p-3 border-1 rounded">
                  <div className="d-flex justify-content-between ps-1">
                    <SkeletonElement type={"title"} />
                    <div className="d-flex">
                      <SkeletonElement type={"title25"} />
                      &nbsp;
                      <div className="d-flex justify-content-center align-items-center">
                        <SkeletonElement type={"title25"} />
                      </div>
                    </div>
                  </div>
                  <div className="ps-1 w-25">
                    <SkeletonElement type={"text"} />
                    <SkeletonElement type={"text"} />
                  </div>
                </div>
                <br />
                <SkeletonElement type={"title"} />
                <br />
                <SkeletonElement type={"title"} />
                <br />
                <SkeletonElement type={"title"} />
                <br />
                <SkeletonElement type={"title"} />
                <br />
              </div>
            </div>
          </div>
        )}
        {loading.status === "Error" && (
          <div className="alert alert-danger bg-white small p-2" role="alert">
            <span className="fas fa-exclamation-triangle" />
            &nbsp;
            <strong>{loading.message}</strong>
          </div>
        )}
        {loading.status === "Success" && loading.message !== undefined && (
          <div className="alert alert-primary bg-white small p-2" role="alert">
            <span className="far fa-check-circle" />
            &nbsp;
            <strong>{loading.message}</strong>
          </div>
        )}
      </>
    );
  };
  
export default LoadingSuccessErrorAlert